import SetState from "../typings/SetState";

/**
 * delete/add elements from a dropdown list
 *
 * @param {*} target the clicked element
 * @param {*} data the dataset containing the element
 * @param {*} setData the useState function to set the state
 */
const clickElementHandler = (
  element: any,
  data: any[],
  setData: SetState<any>
) => {
  let arr = [...data];

  if (arr.includes(element)) {
    let index = arr.indexOf(element);
    arr.splice(index, 1);
  } else {
    arr.push(element);
  }

  setData(arr);
};

export default clickElementHandler;
